<div class="page-body">
  <div *ngIf="loading">
    <app-spinner></app-spinner>
  </div>

  <div *ngIf="!loading">
    <div class="banner">
      <button type="button" class="back-button" (click)="changeAccount()">
        <app-zaver-icon [size]="14" name="chevronLeft"></app-zaver-icon>
        <span class="back-text">Tillbaka</span>
      </button>
    </div>

    <div class="contents-wrapper">
      <div class="contents-container">
        <div
          *ngIf="state.zaverProduct === ZAVERPRODUCT.TOKENIZED_ONBOARDING"
          class="extra-padding"
        >
          <div class="page-icon-tp">
            <app-zaver-icon [size]="86" name="tpCircle"></app-zaver-icon>
          </div>

          <div class="heading">
            Aktivera {{ getMethodName() }} hos
            {{ state.checkoutCustomizations.merchantName }}
          </div>
        </div>

        <div
          *ngIf="
            state.zaverProduct ===
            ZAVERPRODUCT.TOKENIZED_ONBOARDING_WITH_PAYMENT
          "
          class="heading"
        >
          Strax klart.
        </div>

        <div class="sub-heading">
          Vänligen kontrollera att nedanstående är korrekt.
        </div>

        <div
          *ngIf="
            state.zaverProduct ===
            ZAVERPRODUCT.TOKENIZED_ONBOARDING_WITH_PAYMENT
          "
        >
          <hr class="details-divider" />

          <div class="details-container">
            <div class="details-key-entry">
              {{ state.paymentInformation?.title }}
            </div>
            <div class="details-value-entry">
              <zaver-button-link
                [text]="'Ditt köp'"
                (click)="showPurchaseInformation()"
              ></zaver-button-link>
            </div>
          </div>

          <hr class="details-divider" />

          <div class="details-container">
            <div class="details-key-entry">Totalbelopp</div>
            <div class="details-value-entry details">
              {{ state.totalCheckoutValue | value }}
            </div>
          </div>
        </div>

        <div>
          <hr class="details-divider" />

          <div class="details-container">
            <div class="details-key-entry">
              {{ accountInformation?.bank }}
            </div>
            <div class="details-value-entry details">
              {{ accountInformation?.description }}
            </div>
          </div>

          <hr class="details-divider" />

          <div class="change-bank-account">
            <zaver-button-link
              text="Byt bank eller konto"
              (click)="changeAccount()"
            ></zaver-button-link>
          </div>

          <div class="terms-text">
            Genom att signera godkänner du autogiro-betalningar från angivet
            konto till Zaver (Frink AB) samt
            <zaver-button-link
              text="villkoren för betalning."
              (click)="showTerms()"
            ></zaver-button-link>
          </div>
        </div>

        <div class="button-container">
          <zaver-primary-button
            [buttonType]="'submit'"
            [formId]="'email-and-phone-form'"
            text="Slutför"
            (click)="handleCtaClick()"
          ></zaver-primary-button>
        </div>
      </div>
    </div>
  </div>
</div>

<zaver-checkout-modal
  *ngIf="selectorItems && modalActive"
  [buttonText]="'Stäng'"
  [title]="'Visa detaljer'"
  (onClose)="toggleModal()"
>
  <app-selector
    #selector
    [selectorItems]="selectorItems"
    [selectedItem]="selectedItem"
  ></app-selector>
</zaver-checkout-modal>
